import React, { Component } from "react";
import { Fab, Grid, CircularProgress, Modal } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import axios from "axios";
import { fontColor, primaryColor, webFont } from "../../config/theme";
import ImageCropper from "./image-cropper";
import { IMAGE_API } from "../../config/constants";
import {imageSizeValidator} from "./image-validator";

class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, uploadedData: null, selectedImage: null, isModalOpen: false };
  }

  setLoading = loading => {
    this.setState({ loading });
  };

  uploadAPI = files => {
    const { onSuccess, onError, fileType, onUploadStart } = this.props;
    let formData = new FormData();
    formData.append("imgfile", files);
    formData.append("fileType", fileType);
    this.closeModal();
    const token = window.localStorage.getItem("ccZestyAuthToken");
    this.setLoading(true);
    onUploadStart(true);
    axios
      .post(`${IMAGE_API}/img-upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${window.localStorage.getItem("ccZestyAuthToken")}`
        }
      })
      .then(uploadedData => {
        this.setState({ uploadedData });
        this.setLoading(false);
        onSuccess(uploadedData);
        if (document.getElementById('contained-button-file'))
          document.getElementById('contained-button-file').value = null;
      })
      .catch(err => {
        console.log(err);
        onError(err);
        this.setLoading(false);
        if (document.getElementById('contained-button-file'))
          document.getElementById('contained-button-file').value = null;
      });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
    if (document.getElementById('contained-button-file'))
      document.getElementById('contained-button-file').value = null;
  };

  imageAfterValidation = (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.setState({ selectedImage: reader.result, isModalOpen: true });
    }, false);
    reader.readAsDataURL(file);
  };

  render() {
    let { loading } = this.state;
    const { page } = this.props;

    return (
      <Grid item xs={12} sm={6} md={4} lg={4} style={page === 'post' ? styles.addMediaBoxPost : page === 'add-dish' ? styles.addMediaBoxDish : styles.addMediaBoxCommon}>
        <Grid
          container
          alignItems="center"
          justify="center"
          alignContent="center"
        >
          <input
            accept="image/*"
            id="contained-button-file"
            type="file"
            style={{ display: "none" }}
            name="images"
            onChange={data => {
              const files = data.target.files;
              imageSizeValidator(files, this.imageAfterValidation, this.closeModal)
            }}
          />
          {!loading && (
            <label htmlFor="contained-button-file">
              <Fab
                color="primary"
                aria-label="Add"
                component="span"
                size="small"
                style={styles.btnPlus}
              >
                <Add data-test-id={"addimg-id"} style={styles.btnIcon} />
              </Fab>
            </label>
          )}
          {loading && <CircularProgress />}
        </Grid>
        <Modal
          open={this.state.isModalOpen}
          onClose={this.closeModal}
          aria-labelledby="image-cropper"
          aria-describedby="image-cropper-modal"
        >
          <ImageCropper img={this.state.selectedImage} uploadImage={this.uploadAPI} imgType={this.props.fileType} />
        </Modal>
      </Grid>
    );
  }
}

export default FileUpload;
const styles = {
  btnPlus: {
    boxShadow: 'none',
  },
  setFont: {
    fontFamily: webFont
  },
  heavy: {
    fontWeight: 800
  },
  littleHeavy: {
    fontWeight: 600
  },
  addMediaBoxPost: {
    width: 320,
    height: 240,
    maxWidth: 320,
    maxHeight: 240,
    border: '1px solid #ff8000',
    marginRight: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addMediaBoxDish: {
    width: 320,
    height: 240,
    maxWidth: 320,
    maxHeight: 240,
    border: '1px solid #ff8000',
    marginRight: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addMediaBoxCommon: {
    width: 210,
    height: 140,
    maxWidth: 210,
    maxHeight: 140,
    border: '1px solid #ff8000',
    marginRight: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addMediaBox: {
    maxWidth: 512,
    height: 305,
    border: '1px solid #ff8000',
    marginRight: 17,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  btnPlusDishes: {
    marginLeft: 150
  },
  btnIcon: {
    color: fontColor
  },
  btnDishType: {
    borderRadius: "50%",
    borderColor: primaryColor,
    minWidth: 36,
    minHeight: 32,
    marginRight: 30,
    marginBottom: 10,
    borderWidth: 1,
    borderStyle: "solid",
    color: primaryColor,
    backgroundColor: "#fff"
  },
  btnDishTypeSelected: {
    borderRadius: "50%",
    borderColor: primaryColor,
    borderWidth: 1,
    borderStyle: "solid",
    color: fontColor,
    backgroundColor: primaryColor,
    minWidth: 36,
    minHeight: 32,
    marginRight: 30,
    marginBottom: 10
  },
  dishTypeDet: {
    fontSize: 10
  }
};
